import { render } from "./testing-playground.vue?vue&type=template&id=50065e14&scoped=true"
import script from "./testing-playground.vue?vue&type=script&lang=js"
export * from "./testing-playground.vue?vue&type=script&lang=js"

import "./testing-playground.vue?vue&type=style&index=0&id=50065e14&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50065e14"]])

export default __exports__